import throttle from 'lodash/throttle'
import * as Sentry from '@sentry/vue'
import { isFeatureEnabled } from '@/vuex/modules/featureToggles.module'
import { scrollToActiveSlide } from '@/utils/dom.utils'
import { WHEEL_THROTTLE_TIME } from '@/constant/fixedTime'
import { shouldEnableScrollToSlide } from '@/utils/scrollPreventionService'
import EventBus from '@/eventBus'
import constants from '@/constant'
import utils from '@/util'
import UnleashService from '@/services/unleash'

const trackWheelScrollUp = (rootState) => {
  const eventAction = 'Select slide by mouse wheel'
  const trackData = {
    eventAction,
    eventCategory: constants.eventCategories.PRESENTATION_EDITOR,
    eventLabel: 'Wheel up',
    presentationId: rootState.presentation.id,
    userId: rootState.currentUser.id,
  }
  utils.trackGA4AndMixpanel(eventAction, trackData)
}

const trackWheelScrollDown = (rootState) => {
  const eventAction = 'Select slide by mouse wheel'
  const trackData = {
    eventAction,
    eventCategory: constants.eventCategories.PRESENTATION_EDITOR,
    eventLabel: 'Wheel down',
    presentationId: rootState.presentation.id,
    userId: rootState.currentUser.id,
  }
  utils.trackGA4AndMixpanel(eventAction, trackData)
}

const handleScrollUp = (rootState, rootGetters) => {
  EventBus.$emit('SideLeft: deselectAllSlides')

  const previousSlide = rootGetters.getPreviousSlide({ slideOrder: rootState.slideActive?.order })
  if (!previousSlide) return

  EventBus.$emit('makeSlideActive', previousSlide, previousSlide?.deleted)
  scrollToActiveSlide()
  trackWheelScrollUp(rootState)
}

const handleScrollDown = (rootState, rootGetters) => {
  EventBus.$emit('SideLeft: deselectAllSlides')

  const nextSlide = rootGetters.getNextSlide({ slideOrder: rootState.slideActive?.order })
  if (!nextSlide) return

  EventBus.$emit('makeSlideActive', nextSlide, nextSlide?.deleted)
  scrollToActiveSlide()
  trackWheelScrollDown(rootState)
}

const _state = {

}

const _getters = {

}

const mutations = {

}

const actions = {
  async initWheelScrollAction({ rootGetters, dispatch }, element) {
    try {
      if (!element || !UnleashService) return

      UnleashService.start()
      await UnleashService.ready
      if (isFeatureEnabled(rootGetters, 'release-wheel-to-scroll-through-slide-list')) {
        dispatch('handleOnMouseWheelEventAction', element)
      }
    } catch (error) {
      Sentry.captureException(error)
    }
  },

  handleOnMouseWheelEventAction({ rootState, rootGetters }, element) {
    if (!element) return

    const throttledWheelHandler = throttle((event) => {
      if (rootGetters.isPresenting || rootGetters.isSharingView || rootGetters.isBackstage) return

      // Use the centralized service to check if scroll-to-slide should be enabled
      if (!shouldEnableScrollToSlide(event)) return

      if (event.deltaY < 0) {
        handleScrollUp(rootState, rootGetters)
      } else if (event.deltaY > 0) {
        handleScrollDown(rootState, rootGetters)
      }
    }, WHEEL_THROTTLE_TIME)

    // Add wheel event listener with throttled handler
    element.addEventListener('wheel', (event) => {
      throttledWheelHandler(event)
    })
  },
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
}
